import UrlConstant from "../helpers/UrlConstant";

export let get = async (base64Id) => {
  try {
    const response = await fetch(UrlConstant.MatchList + base64Id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        //   Authorization:
        //     "Bearer " +
        //     JSON.parse(
        //       await Utilities.asyncStorage_GetKey(Constants.Session.JWT_TOKEN)
        //     ),
      },
    });
    if (response.status == 200) {
      const result = await response.json();
      // console.log('response', result)
      return result;
    }
    const result = await response.json();
    return { message: result[0] };

    // console.log('result', result)
    //   localStorage.setItem(Constants.Session.JWT_TOKEN,result);
  } catch (e) {
    console.error(e);
  }
};

export const getStream = async (id) => {
  try {
    const response = await fetch(UrlConstant.refereeStream + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    console.log('response getRefereeStream',response);
    
    if (response.status == 200) {
      const result = await response.json();
      return result;
    }
    const result = await response.json();
    return { message: result[0] };
  } catch (e) {
    console.error(e);
  }
};
